import {BOOKING_DATE_RANGE, CHECKOUT_DATE_RANGE} from "features/reservations/reservationDateRange";
import {PLATFORM_OPTIONS,BILLING_MODE_OPTIONS,BOOKING_STATUS_OPTIONS, DESIGNATION_PLATFORM_OPTIONS, OTHER_ADS_OPTIONS} from "features/reservations/reservationFilterOptions";
export const reservationFilterOptions = [
    {
        id: "idPlatForm",
        label: "Channel",
        type: "multiSelect",
        placeholder: "Select Channel",
        options: [...PLATFORM_OPTIONS],
        designationOptions: [...DESIGNATION_PLATFORM_OPTIONS],
        otherAdsOptions: [...OTHER_ADS_OPTIONS],
        multi: true,
    },
    {
        id: "bookingMonth",
        label: "Booking Month",
        type: "select",
        placeholder: "Select Month",
        options: [...BOOKING_DATE_RANGE],
        multi: false,
    },
    {
        id: "checkOutMonth",
        label: "Check-out Month",
        type: "select",
        placeholder: "Select Month",
        options: [...CHECKOUT_DATE_RANGE],
        multi: false,
    },
    {
        id: "bookingStatus",
        label: "Status",
        type: "select",
        placeholder: "Status",
        options: [...BOOKING_STATUS_OPTIONS],
        multi: true,
    },
    {
        id: "billingMode",
        label: "Billing",
        type: "select",
        placeholder: "Select Mode",
        options: [...BILLING_MODE_OPTIONS],
        multi: true,
    },
];